// extracted by mini-css-extract-plugin
export default {"item":"DocumentListItem_item__UJhVc","icon":"DocumentListItem_icon__LfdCf"};